import { useState } from "react";

export const ActivationAuditTable = ({ bypassCandidates = [], bypassSubmitting = false, onAdminBypass, rows = [] }) => {
  const [selectedAgentId, setSelectedAgentId] = useState(bypassCandidates[0]?.id || "");

  return (
    <div className="rounded-[32px] border border-[#001935]/10 bg-white p-6 shadow-[0_24px_70px_rgba(0,25,53,0.08)]" data-testid="activation-audit-table-card">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]">Founder’s Audit Trail</p>
          <h2 className="mt-3 font-[Cormorant_Garamond,serif] text-4xl font-bold leading-none text-[#001935]">Activation history for the first live cohort.</h2>
        </div>
        <div className="rounded-full border border-[#001935]/10 bg-[#f8fafc] px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#42566f]" data-testid="activation-audit-table-count-pill">
          {rows.length} audit entries
        </div>
      </div>

      <div className="mt-6 grid gap-4 md:hidden" data-testid="activation-audit-mobile-card-list">
        {rows.map((row) => (
          <div className="rounded-[24px] border border-[#001935]/10 bg-[#fffaf1] p-5 shadow-[0_16px_45px_rgba(0,25,53,0.06)]" data-testid={`activation-audit-mobile-card-${row.seat_number}`} key={`mobile-${row.id || row.agent_id}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-lg font-semibold text-[#001935]">{row.agent_name}</p>
                <p className="mt-1 text-xs font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Seat {row.seat_number}</p>
              </div>
              <span className={`rounded-full px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] ${row.lead_routing_verified ? "bg-[#E8F6EC] text-[#2F7A49]" : "bg-[#FDECEC] text-[#A34A42]"}`} data-testid={`activation-audit-mobile-routing-${row.seat_number}`}>
                {row.lead_routing_verified ? "Routing Verified" : "Routing Pending"}
              </span>
            </div>
            <div className="mt-4 grid gap-3 sm:grid-cols-2">
              <div className="rounded-[18px] border border-[#001935]/10 bg-white px-4 py-3">
                <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Role status</p>
                <p className="mt-2 text-sm font-semibold text-[#001935]">{row.role_status}</p>
              </div>
              <div className="rounded-[18px] border border-[#001935]/10 bg-white px-4 py-3">
                <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Activation time</p>
                <p className="mt-2 text-sm font-semibold text-[#001935]">{row.activation_timestamp}</p>
              </div>
              <div className="rounded-[18px] border border-[#001935]/10 bg-white px-4 py-3">
                <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Quality score</p>
                <p className="mt-2 text-sm font-semibold text-[#001935]">{row.latest_playbook_quality_score ? `${row.latest_playbook_quality_score}/10` : "—"}</p>
              </div>
              <div className="rounded-[18px] border border-[#001935]/10 bg-white px-4 py-3">
                <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Playbook tokens</p>
                <p className="mt-2 text-sm font-semibold text-[#001935]">{row.latest_playbook_tokens ?? "—"}</p>
              </div>
            </div>
            <div className="mt-4 rounded-[18px] border border-[#001935]/10 bg-white px-4 py-3 text-sm leading-7 text-[#42566f]" data-testid={`activation-audit-mobile-playbook-${row.seat_number}`}>
              {row.latest_playbook_script || "No playbook logged yet"}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 hidden overflow-x-auto rounded-[24px] border border-[#001935]/8 md:block">
        <table className="min-w-full divide-y divide-[#001935]/8 text-left text-sm" data-testid="activation-audit-table">
          <thead className="bg-[#f8fafc] text-xs font-bold uppercase tracking-[0.18em] text-[#5e6e82]">
            <tr>
              <th className="px-4 py-3">Agent Name</th>
              <th className="px-4 py-3">Role Status</th>
              <th className="px-4 py-3">Stripe Session ID</th>
              <th className="px-4 py-3">Activation Timestamp</th>
              <th className="px-4 py-3">Seat Number</th>
              <th className="px-4 py-3">Lead Routing Verified</th>
              <th className="px-4 py-3">Playbook Quality Score</th>
              <th className="px-4 py-3">Playbook Tokens</th>
              <th className="px-4 py-3">Latest Reply Playbook</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#001935]/8 text-[#31455f]">
            {rows.map((row) => (
              <tr key={row.id || row.agent_id} data-testid={`activation-audit-row-${row.seat_number}`}>
                <td className="px-4 py-3 font-semibold text-[#001935]">{row.agent_name}</td>
                <td className="px-4 py-3">{row.role_status}</td>
                <td className="px-4 py-3 text-xs text-[#5e6e82]">{row.stripe_session_id}</td>
                <td className="px-4 py-3">{row.activation_timestamp}</td>
                <td className="px-4 py-3">Seat {row.seat_number}</td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] ${row.lead_routing_verified ? "bg-[#E8F6EC] text-[#2F7A49]" : "bg-[#FDECEC] text-[#A34A42]"}`} data-testid={`activation-audit-routing-${row.seat_number}`}>
                    {row.lead_routing_verified ? "Verified" : "Pending"}
                  </span>
                </td>
                <td className="px-4 py-3" data-testid={`activation-audit-quality-${row.seat_number}`}>{row.latest_playbook_quality_score ? `${row.latest_playbook_quality_score}/10` : "—"}</td>
                <td className="px-4 py-3" data-testid={`activation-audit-tokens-${row.seat_number}`}>{row.latest_playbook_tokens ?? "—"}</td>
                <td className="max-w-[320px] px-4 py-3 text-xs leading-6 text-[#42566f]" data-testid={`activation-audit-playbook-${row.seat_number}`}>{row.latest_playbook_script || "No playbook logged yet"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-6 rounded-[24px] border border-[#D4AF37]/22 bg-[#fff8ea] p-5" data-testid="activation-audit-bypass-card">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]">Super-Admin Hosted-Checkout Bypass</p>
        <p className="mt-2 text-sm leading-7 text-[#5e6e82]">Hosted Stripe Checkout remains the default path. Admin can still trigger the Direct API bypass here for future Founding 18 seats.</p>
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <select className="rounded-full border border-[#001935]/12 bg-white px-4 py-2 text-sm text-[#001935]" data-testid="activation-audit-bypass-select" onChange={(event) => setSelectedAgentId(event.target.value)} value={selectedAgentId}>
            <option value="">Select agent</option>
            {bypassCandidates.map((candidate) => (
              <option key={candidate.id} value={candidate.id}>{candidate.name}</option>
            ))}
          </select>
          <button className="gold-button" data-testid="activation-audit-bypass-button" disabled={!selectedAgentId || bypassSubmitting} onClick={() => onAdminBypass?.(selectedAgentId)} type="button">
            {bypassSubmitting ? "Activating..." : "Run Admin Bypass"}
          </button>
        </div>
      </div>
    </div>
  );
};